import { MealTypeEnum } from '../SelfMonitoring';

export enum DiabetesTypeEnum {
  TYPE_1 = 'TYPE_1',
  TYPE_2 = 'TYPE_2',
  INSULIN_RESISTANCE = 'INSULIN_RESISTANCE',
  PREDIABETES = 'PREDIABETES',
}

export enum SexType {
  female = 'emale',
  male = 'male',
}

export enum InsulinDeliveryMethodEnum {
  PENS = 'PENS',
  PUMP = 'PUMP',
}

export enum InsulinTypeEnum {
  SHORT_ACTING = 'SHORT_ACTING',
  LONG_ACTING = 'LONG_ACTING',
}

export enum DietModeType {
  slimming = 'slimming',
  stabilization = 'stabilization',
  put_on_weight = 'put_on_weight',
  gain_muscle_mass = 'gain_muscle_mass',
}

export type InsulinToCarbRatio = {
  mealType: number;
  mealTypeEnum: MealTypeEnum;
  ratio: number;
};

export type Insulin = {
  id: number;
  name: string;
  type: InsulinTypeEnum;
};

export enum DietIdEnum {
  DIET_ID_CLASSIC = 'DIET_ID_CLASSIC',
  DIET_ID_STANDARD = 'DIET_ID_STANDARD',
  DIET_ID_VEGE = 'DIET_ID_VEGE',
  DIET_ID_VEGAN = 'DIET_ID_VEGAN',
  DIET_ID_HIGH_PROTEIN = 'DIET_ID_HIGH_PROTEIN',
  DIET_ID_HIGH_PROTEIN2 = 'DIET_ID_HIGH_PROTEIN2',
  DIET_ID_ANTY_JOJO = 'DIET_ID_ANTY_JOJO',
  DIET_ID_GLUTEN_DAIRY_FREE = 'DIET_ID_GLUTEN_DAIRY_FREE',
  DIET_ID_LOW_IG = 'DIET_ID_LOW_IG',
  DIET_ID_SMART = 'DIET_ID_SMART',
  DIET_ID_CLASSIC_LVL2 = 'DIET_ID_CLASSIC_LVL2',
  DIET_ID_CLASSIC_LVL3 = 'DIET_ID_CLASSIC_LVL3',
  DIET_ID_BUDGET = 'DIET_ID_BUDGET',
  DIET_ID_GLP1 = 'DIET_ID_GLP1',
  DIET_ID_GLP1_FRIENDLY = 'DIET_ID_GLP1_FRIENDLY',
  DIET_ID_GLP1_CLASSIC = 'DIET_ID_GLP1_CLASSIC',
  DIET_ID_HIGH_PROTEIN_VEGE = 'DIET_ID_HIGH_PROTEIN_VEGE',
  DIET_ID_COMFORT = 'DIET_ID_COMFORT',
  DIET_ID_INSTANT = 'DIET_ID_INSTANT',
  DIET_ID_SIMPLE = 'DIET_ID_SIMPLE',
  DIET_ID_SIMPLE_ANTY_JOJO = 'DIET_ID_SIMPLE_ANTY_JOJO',
}

export enum DietActivityLevelType {
  ACTIVITY_LEVEL_NONE = 'ACTIVITY_LEVEL_NONE',
  ACTIVITY_LEVEL_LOW = 'ACTIVITY_LEVEL_LOW',
  ACTIVITY_LEVEL_MEDIUM = 'ACTIVITY_LEVEL_MEDIUM',
  ACTIVITY_LEVEL_HIGH = 'ACTIVITY_LEVEL_HIGH',
}

export enum DietSpontaneousActivityLevelType {
  SPONTANEOUS_ACTIVITY_LEVEL_NONE = 'low',
  SPONTANEOUS_ACTIVITY_LEVEL_LOW = 'lightly',
  SPONTANEOUS_ACTIVITY_LEVEL_MEDIUM = 'moderately',
  SPONTANEOUS_ACTIVITY_LEVEL_HIGH = 'very_active',
}

export enum BloodSugarUnitEnum {
  MG_DL = 'MG_DL',
  MMOL_L = 'MMOL_L',
}

export type BloodSugar = {
  value: string | number;
  unit: BloodSugarUnitEnum;
};

export type OptimalBloodSugarTarget = {
  min: BloodSugar;
  max: BloodSugar;
};

export enum UserMeasurementHeightUnitType {
  cm = 'cm',
  in = 'in',
}

export type UserMeasurementHeightInputType = {
  value: number;
  unit: UserMeasurementHeightUnitType;
};

export enum UserMeasurementWeightUnitType {
  kg = 'kg',
  lb = 'lb',
}

export type UserMeasurementWeightInputType = {
  value: number;
  unit: UserMeasurementWeightUnitType;
};

export enum TreatmentMethodEnum {
  INSULIN = 'INSULIN',
  NON_INSULIN_MEDICINES = 'NON_INSULIN_MEDICINES',
  WITHOUT_PHARMACOTHERAPY = 'WITHOUT_PHARMACOTHERAPY',
}

export type InsulinToCarbRatioInputType = {
  mealType: number;
  ratio: number;
};

export type PersonalDataInput = {
  sex: SexType;
  dateOfBirth: Date;
  height: UserMeasurementHeightInputType | null;
};

export type DietSettingsInput = {
  weight: UserMeasurementWeightInputType | null;
  dietMode: DietModeType;
  goalWeight: UserMeasurementWeightInputType | null;
  dietId: number;
  activityLevel: DietActivityLevelType;
};

export type TreatmentInputType = {
  treatmentMethods?: TreatmentMethodEnum[];
  insulinDeliveryMethod?: InsulinDeliveryMethodEnum;
  longActingInsulinId?: number;
  longActingInsulinDose?: number;
  shortActingInsulinId?: number;
  insulinToCarbRatios?: InsulinToCarbRatioInputType[] | null;
  insulinCorrectionFactor?: number;
  optimalBloodSugarTarget?: OptimalBloodSugarTarget;
  bloodSugarUnit?: BloodSugarUnitEnum;
};

export type diabetesInputType = {
  type: DiabetesTypeEnum;
  treatment: TreatmentInputType;
};

/**
 * Freemium availability of a single diet.
 *
 * - `isAvailable: false` — the diet is out of reach for freemium users
 * - `isAvailable: true` with `freeDays: null` — fully available
 * - `isAvailable: true` with a positive `freeDays` — available for that many days
 */
export type DietFreemiumAccess = {
  isAvailable: boolean;
  freeDays: number | null;
};

export type DietFreemiumAccessEntry = {
  id: number;
  freemiumAccess: DietFreemiumAccess | null;
};

export type DietsFreemiumAccessResult = {
  me: {
    id: number;
    diet: {
      id: number;
      accessTo: string | null;
    } | null;
  } | null;
  diet: {
    diets: DietFreemiumAccessEntry[];
  };
};
